import { render, staticRenderFns } from "./applyAfterSales.vue?vue&type=template&id=4197eaca&"
import script from "./applyAfterSales.vue?vue&type=script&lang=js&"
export * from "./applyAfterSales.vue?vue&type=script&lang=js&"
import style0 from "./applyAfterSales.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/jenkins/workspace/product_operation/package_operation-saasmobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4197eaca')) {
      api.createRecord('4197eaca', component.options)
    } else {
      api.reload('4197eaca', component.options)
    }
    module.hot.accept("./applyAfterSales.vue?vue&type=template&id=4197eaca&", function () {
      api.rerender('4197eaca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/applyAfterSales.vue"
export default component.exports